import { render } from "./OrderContracts.vue?vue&type=template&id=0459f3a6&scoped=true"
import script from "./OrderContracts.vue?vue&type=script&lang=js"
export * from "./OrderContracts.vue?vue&type=script&lang=js"

import "./OrderContracts.vue?vue&type=style&index=0&id=0459f3a6&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0459f3a6"]])

export default __exports__